@if (bodyImage) {
<div class="current-media" [class.h-75]="!fullSpace">
  <div class="img-fluid" (click)="clickedImage()">
    @if (!useMissingImageContent) {
    <atx-image
      class="w-100 h-100"
      [imageUrl]="bodyImage"
      [imageBreakpoints]="imageBreakpoints"
      [enableProgressiveLoad]="progressiveImageLoad"
      (imageLoaded)="onMainImageLoaded()"
      (imageError)="onMainImageError()"
      (mouseenter)="onMainImageMouseEnter()"
      (mouseleave)="onMainImageMouseLeave()"
      data-e2e="current-media"
      [fallbackImageUrl]="placeholderImage"
    >
    </atx-image>
    } @else {
    <ng-container
      [ngTemplateOutlet]="missingImageTemplate"
      [ngTemplateOutletContext]="{ $implicit: currentIndex }"
    ></ng-container>
    }
  </div>
  <ng-content select=".carousel-card-info"></ng-content>
</div>
}

<div class="thumbnails-wrapper" [class.d-none]="!thumbnailsVisible">
  @if (thumbnailsVisible) {
  <div
    class="thumbnails"
    [ngClass]="{
      'position-relative pt-1': !fullSpace,
      'position-absolute pb-1': fullSpace
    }"
    [@inOutAnimation]
  >
    @if (!showMoreImagesIndicator) {
    <span class="control">
      @if (isPreviousEnabled()) {
      <fa-icon
        (click)="selectPrevious($event)"
        data-e2e="control-prev"
        [icon]="['fas', 'angle-left']"
      ></fa-icon>
      }
    </span>
    } @if (!showThumbnailsSkeleton) { @for (media of indicators; track media;
    let i = $index) {
    <div
      class="thumbnail rounded-0"
      [class.active]="isActive(i)"
      (click)="indicatorClicked(i)"
      data-e2e="thumbnail"
    >
      @if (useMissingImageContentForThumbnail(i)) {
      <div
        class="w-100 h-100"
        [style.transform]="'scale(' + zoomFactorThubmailMissingImage + ')'"
      >
        <ng-container
          [ngTemplateOutlet]="missingImageTemplate"
          [ngTemplateOutletContext]="{ $implicit: i }"
        ></ng-container>
      </div>
      } @else {
      <atx-image
        [imageBreakpoints]="carouselBreakpoints"
        [imageUrl]="getThumbSrcSet(media.url)"
        [enableProgressiveLoad]="progressiveImageLoad"
        [fallbackImageUrl]="placeholderImage"
        (imageLoaded)="onThumbnailImageLoaded(i)"
        (imageError)="onThumbnailImageError(i)"
      ></atx-image>
      }
    </div>
    } } @else { @for (media of indicators; track media) {
    <div class="thumbnail rounded-0" data-e2e="thumbnail">
      <atx-skeleton-basic height="3rem" width="3rem"></atx-skeleton-basic>
    </div>
    } } @if (!showMoreImagesIndicator) {
    <span class="control">
      @if (isNextEnabled()) {
      <fa-icon
        [icon]="['fas', 'angle-right']"
        (click)="selectNext($event)"
        data-e2e="control-next"
      ></fa-icon>
      }
    </span>
    } @if (showMoreImagesIndicator && getOverflow() > 0) {
    <span class="overflow-number" [atxTooltip]="moreImagesIndicatorTooltip">
      +{{ getOverflow() }}
    </span>
    }
  </div>
  }
</div>
